import React, { useEffect , useState } from 'react';

 import Termsapp from "../components/Terms";

export default function Terms() {
 

    return (
    <>
        <Termsapp   className="mt-40" />
    </>
  );
}
